import { createContext, PropsWithChildren, useContext } from 'react';
import { PricingPackagesFormValues } from '../../../../../store/features/packages/types';

export interface SelectPackageProviderProps {
  handleChangeSelections: (
    defaultValues?: PricingPackagesFormValues,
  ) => Promise<unknown>;
}

const MyContext = createContext({} as SelectPackageProviderProps);

export const SelectPackageProvider = (
  props: PropsWithChildren<SelectPackageProviderProps>,
) => {
  const { handleChangeSelections, children } = props;

  return (
    <MyContext.Provider
      value={{
        handleChangeSelections,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useSelectPackageContext = () =>
  useContext<SelectPackageProviderProps>(MyContext);
